import { render, staticRenderFns } from "./SmOwBtnText.vue?vue&type=template&id=270aa8ff&scoped=true&"
import script from "./SmOwBtnText.vue?vue&type=script&lang=ts&"
export * from "./SmOwBtnText.vue?vue&type=script&lang=ts&"
import style0 from "./SmOwBtnText.vue?vue&type=style&index=0&id=270aa8ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270aa8ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
